import { apiCaller } from '@/api/apiCaller';
import { apihost } from '@/api/urls';

const getAll = () => apiCaller.get('/vehicletype/', apihost);

export const vehicleApi = {
    getAll,
};
